<template>
  <div>
    <span class="icon" :class="{ 'no-pass' : noPass }"></span>
    <p class="tip">{{tipText}}。</p>
    <!--<div v-if="!goExam" class="btn-wrap">-->
      <!--<span class="empty-btn" v-if="!noPass" @click="playVideo">考前必看</span>-->
      <!--<span class="btn" v-if="noPass" @click="rusultFunc">重新检测</span>-->
      <!--<span class="btn" v-if="!noPass && showTest" @click="rusultFunc">模拟考试</span>-->
    <!--</div>-->
    <div class="btn-wrap">
      <span class="btn" v-if="noPass" @click="rusultFunc">重新检测</span>
      <span class="empty-btn" v-if="noPass" @click="openTip">已知风险，进入</span>
      <span class="btn" v-if="!noPass" @click="goTest">进入考试</span>
    </div>
    <table width="900" border="1" class="adminssion-table extra">
      <template v-if="detectTypes.includes(1)">
        <tr class="about-pc">
          <td class="title" width="149" rowspan="4">
            <p class="icon-wrap"><icon-white-pc class="pc-icon"></icon-white-pc></p>
            网络与设备检测
          </td>
          <td class="summary" width="520">
            系统版本：{{pcInfo.OS}} {{pcInfo.osVersion}}
            <p v-if="osTip" class="normal-tip" :class="{ 'error-tip': statusFunc(detectOs) === 'error' }">{{osTip}}</p>
          </td>
          <td>
            <span class="icon-func" :class="statusFunc(detectOs)"></span>
            {{ detectOs | formateTxt}}
            <a v-if="detectOs !== status.pass" class="solve" href="https://shimo.im/docs/TXwhDQrD3J6d3yvv">解决方案</a>
          </td>
        </tr>
        <tr class="about-pc">
          <td>
            浏览器：{{pcInfo.browser}}  ({{pcInfo.browserVersion.split('/')[1]}})
            <p  v-if="versionTip" class="normal-tip" :class="{ 'error-tip': statusFunc(detectVersion) === 'error' }">{{versionTip}}
              <a class="download" :href="googleUrl">下载</a>
            </p>
          </td>
          <td>
            <span class="icon-func" :class="statusFunc(detectVersion)"></span>
            {{ detectVersion | formateTxt}}
            <a v-if="detectVersion !== status.pass" target="_blank" class="solve" href="https://education.codemao.cn/207/浏览器异常说明指引.pdf">解决方案</a>
          </td>
        </tr>
        <tr class="about-pc">
          <td>浏览器内核：{{pcInfo.core}}</td>
          <td>
            <span class="icon-func" :class="simpleFunc(pcInfo.core, 'Chromium')"></span>
            {{pcInfo.core === 'Chromium' ? '通过' : '异常'}}
            <a v-if="pcInfo.core !== 'Chromium'" target="_blank" class="solve" href="https://education.codemao.cn/207/浏览器异常说明指引.pdf">解决方案</a>
          </td>
        </tr>
        <tr class="about-pc">
          <td>
            网络：上行网速{{pcInfo.uploadSpeed}} Mbps 下行{{pcInfo.downloadSpeed}} Mbps
            <p v-if="speedTip" class="normal-tip" :class="{ 'error-tip': statusFunc(detectSpeed) === 'error' }">{{speedTip}}</p>
          </td>
          <td>
            <span class="icon-func" :class="statusFunc(detectSpeed)"></span>
            {{ detectSpeed | formateTxt}}
            <a v-if="detectSpeed !== status.pass" target="_blank" class="solve" href="https://education.codemao.cn/207/比赛网络异常说明指引(单机位).pdf">解决方案</a>
          </td>
        </tr>
      </template>
      <tr class="about-micro" v-if="detectTypes.includes(2)">
        <td class="title">
          <p class="icon-wrap"><icon-white-camera class="camera-icon"></icon-white-camera></p>
          摄像头检测
        </td>
        <td class="summary">
          摄像头
          <p v-if="pcInfo.camera !== 'i'" class="error-tip">{{mediaInfo[pcInfo.camera].cameraTip}}</p>
        </td>
        <td>
          <span class="icon-func" :class="simpleFunc(pcInfo.camera, 'i')"></span>
          {{pcInfo.camera === 'i' ? '通过' : '异常'}}
          <span v-if="pcInfo.camera !== 'i'" class="solve" @click="solveCamera">解决方案</span>
        </td>
      </tr>
      <tr class="about-pc about-micro" v-if="detectTypes.includes(3)">
        <td class="title">
          <p class="icon-wrap"><icon-white-micro class="micro-icon"></icon-white-micro></p>
          麦克风检测
        </td>
        <td class="summary">
          麦克风
          <p v-if="pcInfo.micro !== 'i'" class="error-tip">{{mediaInfo[pcInfo.micro].audioTip}}</p>
        </td>
        <td>
          <span class="icon-func" :class="simpleFunc(pcInfo.micro, 'i')"></span>
          {{pcInfo.micro === 'i' ? '通过' : '异常'}}
          <span v-if="pcInfo.micro !== 'i'" class="solve" @click="solveMicro">解决方案</span>
        </td>
      </tr>
    </table>
    <modal
      width="920px"
      speed="fast"
      no-footer
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      :show.sync="showVideo"
    >
      <video
        slot="content"
        ref="video"
        class="video"
        controls
        autoplay
        v-if="showVideo"
        @click="controlVideo"
        :src="introUrl"
      ></video>
    </modal>
    <no-pass-tip-modal v-if="showNoPassTip" @close="showNoPassTip = false" @goTest="goTest"></no-pass-tip-modal>
  </div>
</template>

<script>
import IconWhitePc from '@/assets/svg/detect/icon_white_pc.svg'
import IconWhiteCamera from '@/assets/svg/detect/icon_white_camera.svg'
import IconWhiteMicro from '@/assets/svg/detect/icon_white_micro.svg'
import Modal from '@/components/Modal'
import { getChrome, getExamId } from '@/utils/index'
import NoPassTipModal from './NoPassTipModal'
import { mediaInfo } from '@/utils/common'
import { post } from '@/utils/ajax'
import { mapState } from 'vuex'
import { checkExamIdCard } from '@/apis/exam.api'
export default {
  components: {
    IconWhitePc,
    IconWhiteCamera,
    IconWhiteMicro,
    Modal,
    NoPassTipModal
  },
  inject: ['from'],
  computed: {
    ...mapState(['testConfig']),
    tipText () {
      if (this.noPass) {
        if (this.isOnlyNetworkIssue) {
          return '网络环境检测异常，可能影响考试正常作答'
        } else {
          return '电脑设备检测不通过，可能无法正常考试'
        }
      } else {
        return '当前设备没有任何问题，可以正常考试'
      }
    },
    isOnlyNetworkIssue () {
      // 只有网络问题：其他检测都通过，但网络检测失败
      const otherChecksPass = this.detectOs === this.status.pass &&
                              this.detectVersion === this.status.pass &&
                              this.pcInfo.core === 'Chromium'

      // 检查摄像头和麦克风是否通过（如果检测了的话）
      const cameraPass = !this.detectTypes.includes(2) || this.pcInfo.camera === 'i'
      const microPass = !this.detectTypes.includes(3) || this.pcInfo.micro === 'i'

      return otherChecksPass && cameraPass && microPass && this.detectSpeed === this.status.error
    }
  },
  props: {
    pcInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    detectOs: Number,
    detectVersion: Number,
    detectSpeed: Number,
    osTip: String,
    versionTip: String,
    speedTip: String,
    goExam: Boolean,
    detectTypes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      googleUrl: '',
      showVideo: false,
      introUrl: '',
      showTest: false, // 展示模拟题
      noPass: false,
      status: {
        normal: 1,
        pass: 2,
        error: 0
      },
      mediaInfo: {},
      showNoPassTip: false
    }
  },
  filters: {
    formateTxt (value) {
      if (value === 1) return '一般'
      if (value === 2) return '通过'
      if (value === 0) return '异常'
    }
  },
  mounted () {
    this.googleUrl = getChrome()
    this.mediaInfo = mediaInfo
  },
  methods: {
    async goTest () {
      // 从候考页跳转过来的 && 考试时间到 直接开始考试
      const { testInfo: { exam_id, examinee_id, startExaminee }, user: { id } } = this.$store.state
      if (this.from.name === 'pretest' && startExaminee) {
        if (
          this.testConfig.examType !== 3 && // 不是敏捷考试
          this.testConfig.identityVerification // 需要上传身份证
        ) {
          const examId = getExamId()
          const {
            has_face_info
          } = await checkExamIdCard(examId)
          // 判断是否需要身份证认证
          if (this.testConfig.identityVerification && !has_face_info) {
            this.$router.push({
              name: 'identityCheck',
              query: {
                examId
              }
            })
            return
          }
        }

        await post(`/home/edu/examinees/start/${exam_id}/${examinee_id}`)
        localStorage.setItem('user_id', id)
        this.$router.push({ name: 'test', query: { examId: exam_id } })
        return
      }
      const examId = getExamId()
      this.$router.push({ name: this.from.name || 'list', params: { fromDetect: !!examId } })
    },
    // 跳转解决麦克风方案
    solveMicro () {
      const error_tip = this.pcInfo.micro
      let url = ''
      if (error_tip === 'a') {
        url = 'https://shimo.im/docs/wVTrphdd9kWr9HDr'
      } else if (error_tip === 'b') {
        url = 'https://docs.qq.com/doc/DWFJMeWhWRndiSmxN'
      } else if (error_tip === 'h') {
        url = 'https://shimo.im/docs/vrjhq3yJ6W6kVkgj'
      } else {
        url = 'https://shimo.im/docs/RHTP39wpYxg3xkVp'
      }
      window.open(url, '_blank')
    },
    // 跳转解决摄像头方案
    solveCamera () {
      const error_tip = this.pcInfo.camera
      let url = ''
      if (error_tip === 'a') {
        url = 'https://shimo.im/docs/wVTrphdd9kWr9HDr'
      } else if (error_tip === 'b') {
        url = 'https://docs.qq.com/doc/DWGt0dnpQUmthWU5G'
      } else if (error_tip === 'h') {
        url = 'https://shimo.im/docs/vrjhq3yJ6W6kVkgj'
      } else {
        url = 'https://shimo.im/docs/kCvCRp9VG63wr3gg'
      }
      window.open(url, '_blank')
    },
    // 状态比较
    statusFunc (value) {
      if (value === this.status.normal) return 'normal'
      if (value === this.status.pass) return 'right'
      if (value === this.status.error) {
        this.noPass = true
        return 'error'
      }
    },
    // 简单比较
    simpleFunc (value, example) {
      if (value === example) {
        return 'right'
      } else {
        this.noPass = true
        return 'error'
      }
    },
    playVideo () {
      this.showVideo = true
      this.showTest = true
      this.introUrl = 'https://education.codemao.cn/27/exam/1/2020NCT/考生必看视频-0413.mp4'
    },
    // 显示视频
    controlVideo () {
      const vid = this.$refs.video
      if (vid.paused) {
        vid.play()
      } else {
        vid.pause()
      }
    },
    rusultFunc () {
      if (this.noPass) {
        this.$emit('nextStep', -1)
      } else {
        window.open(`${window.CONFIG.nctsimutest}/nctsimutest`, '_blank')
      }
    },
    openTip() {
      this.showNoPassTip = true
    }
  }
}
</script>

<style lang="scss" scoped>
.video {
  width: 100%;
}
.icon {
  display: block;
  width: 120px;
  height: 84px;
  margin: 40px auto 10px;
  background: url('~@/assets/images/detect/success.png') no-repeat center / cover;
}
.no-pass {
  background: url('~@/assets/images/detect/fail.png') no-repeat center / cover;
}
.tip {
  font-weight: 500;
  color:$titleColor;
  line-height: 28px;
  font-size: 20px;
}
.btn-wrap {
  display: flex;
  justify-content: center;
  margin: 15px auto 30px;
  span + span {
    margin-left: 40px;
  }
}
.btn {
  @include theme-fill-btn(144px, 42px, 16px, 4px);
}
.empty-btn {
  @include theme-empty-btn(144px, 42px, 16px, 4px);
}
.adminssion-table {
  border-collapse: collapse;
  color: $titleColor;
  margin: 0 auto 60px;
  tr {
    text-align: center;
    td {
      position: relative;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      height: 55px;
      color: $titleColor;
      vertical-align: middle;
      border: 1px solid #ddd;
      padding: 20px 0;
    }
    td:nth-child(1), .summary {
      text-align: left;
      padding-left: 14px;
    }
    .title {
      font-size: 16px;
      text-align: center !important;
      font-weight: 500;
      padding: 0 !important;
    }
    td:nth-child(3) {
      min-width: 100px;
    }
  }
}
.icon-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 42px;
  height: 42px;
  margin: 0 auto 5px;
  background: #3090FF;
  border-radius: 50%;
  .pc-icon {
    width: 22px;
    height: 18px;
  }
  .camera-icon {
    width: 17px;
    height: 21px;
  }
  .micro-icon {
    width: 15px;
    height: 20px;
  }
}
.error-tip {
  font-size: 12px;
  color: #FF5030;
}
.normal-tip {
  font-size: 12px;
}
.download {
  cursor: pointer;
  color: #3090FF;
  margin-left: 10px;
}
.icon-func {
  vertical-align: -4px;
  display: inline-block;
  margin-right: 4px;
}
.right {
  width: 19px;
  height: 19px;
  background: url('~@/assets/images/detect/table-right.png') no-repeat center / cover;
}
.error {
  width: 18px;
  height: 18px;
  background: url('~@/assets/images/detect/error.png') no-repeat center / cover;
}
.normal {
  width: 18px;
  height: 18px;
  background: url('~@/assets/images/detect/normal.png') no-repeat center / cover;
}
.solve {
  cursor: pointer;
  position: absolute;
  width: 56px;
  height: 20px;
  color: $themeColor;
  margin-left: 20px;
}
.about-pc {
  background: #FAFAFC;
}
.about-micro {
  height: 110px;
}
</style>
